/**
 * @generated SignedSource<<b0e1b1447df7716222133100b204f559>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Menu_query$data = {
  readonly company: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"HeaderLogo_company">;
  } | null | undefined;
  readonly me: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Candidate_me">;
  } | null | undefined;
  readonly " $fragmentType": "Menu_query";
};
export type Menu_query$key = {
  readonly " $data"?: Menu_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Menu_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Menu_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Candidate",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Candidate_me"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "company",
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "companyDomainName",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeaderLogo_company"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "eb9fe65ae5ac7a90a4f0bd5a32e8a572";

export default node;
